import * as type from "./type";

const initialState = {
  columns: null,
  userColumns: null,
  saved: null,
};

const VendorMemberColumnsReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_MEMBER_COLUMNS_SUCCESS:
      return { ...state, columns: action.payload };
    case type.GET_VENDOR_USER_COLUMNS_REQUEST:
      return { ...state, userColumns: null };
    case type.GET_VENDOR_USER_COLUMNS_SUCCESS:
      return { ...state, userColumns: action.payload };
    case type.SET_VENDOR_USER_COLUMNS_REQUEST:
      return { ...state, saved: null };
    case type.SET_VENDOR_USER_COLUMNS_SUCCESS:
      return { ...state, saved: action.payload };
    default:
      return state;
  }
};

export default VendorMemberColumnsReducer;
